import { getMockItems } from './mockData';

const API_URL = (import.meta.env.VITE_PORTFOLIO_API_URL || '').replace(/\/+$/, '');

export async function fetchItems(type: string): Promise<Record<string, unknown>[]> {
  if (!API_URL) {
    return getMockItems(type);
  }

  const response = await fetch(`${API_URL}/items?type=${type}`);
  if (!response.ok) throw new Error(`Failed to fetch ${type}`);
  const data = await response.json();
  return type === 'PROFILE' ? [data.profile] : data.items;
}

export async function recordVisit(): Promise<number> {
  if (!API_URL) {
    const current = parseInt(localStorage.getItem('mock_visitors') || '0', 10) + 1;
    localStorage.setItem('mock_visitors', String(current));
    return current;
  }

  const response = await fetch(`${API_URL}/visit`, { method: 'POST' });
  if (!response.ok) throw new Error('Failed to record visit');
  const data = await response.json();
  return data.count;
}

export async function fetchStats(): Promise<number> {
  if (!API_URL) {
    return parseInt(localStorage.getItem('mock_visitors') || '0', 10);
  }

  const response = await fetch(`${API_URL}/stats`);
  if (!response.ok) throw new Error('Failed to fetch stats');
  const data = await response.json();
  return data.visitors;
}

export async function submitContact(payload: { name: string; email: string; message: string }): Promise<void> {
  if (!API_URL) {
    console.log('[mock] Contact form submitted:', payload);
    return;
  }

  const response = await fetch(`${API_URL}/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error('Failed to submit contact');
}
